import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { MantineTheme } from '@mantine/core';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

type ColorProps = {
	textColor: string;
	backgroundColor: string;
	iconColor: string;
	onHoverBackgroundColor: string;
	onHoverTextColor: string;
	onHoverIconColor: string;
	variant: React.ComponentProps<typeof Icon>['variant'];
	onHoverVariant: React.ComponentProps<typeof Icon>['variant'];
	text: string;
	toolTipText: string;
	onHoverText: string;
};

export const getKycButtonProps = (
	theme: MantineTheme,
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>
) => {
	const buttonData: Record<string, ColorProps> = {
		ACCEPT: {
			textColor: theme.colors.black[0],
			backgroundColor: theme.colors.gray[2],
			iconColor: theme.colors.teal[8],
			onHoverBackgroundColor: theme.colors.teal[8],
			onHoverTextColor: theme.colors.white[0],
			onHoverIconColor: theme.colors.white[0],
			variant: 'checkbox-tick-l',
			onHoverVariant: 'checkbox-tick-l',
			text: tMipManage('kyc.review.approve.text'),
			toolTipText: tMipManage('kyc.review.tooltip.approve'),
			onHoverText: tMipManage('kyc.review.approve.text'),
		},
		APPROVED: {
			textColor: theme.colors.white[0],
			backgroundColor: theme.colors.teal[8],
			iconColor: theme.colors.black[0],
			onHoverBackgroundColor: theme.colors.orange[6],
			onHoverTextColor: theme.colors.white[0],
			onHoverIconColor: theme.colors.white[0],
			variant: 'close',
			onHoverVariant: 'close',
			text: tMipManage('kyc.review.approved'),
			toolTipText: tMipManage('kyc.review.tooltip.approve'),
			onHoverText: tMipManage('kyc.review.approved'),
		},
		PENDING: {
			textColor: theme.colors.white[0],
			backgroundColor: theme.colors.teal[8],
			iconColor: theme.colors.white[0],
			onHoverBackgroundColor: theme.colors.orange[6],
			onHoverTextColor: theme.colors.white[0],
			onHoverIconColor: theme.colors.white[0],
			variant: 'checkbox-tick-l',
			onHoverVariant: 'minus-circle',
			text: tMipManage('kyc.review.approved'),
			toolTipText: tMipManage('kyc.review.tooltip.approved'),
			onHoverText: tMipManage('kyc.review.unapprove'),
		},
		REJECT: {
			textColor: theme.colors.black[0],
			backgroundColor: theme.colors.gray[2],
			iconColor: theme.colors.red[6],
			onHoverBackgroundColor: theme.colors.red[0],
			onHoverTextColor: theme.colors.red[6],
			onHoverIconColor: theme.colors.red[6],
			variant: 'close',
			onHoverVariant: 'close',
			text: tMipManage('kyc.review.decline'),
			toolTipText: tMipManage('kyc.review.tooltip.decline'),
			onHoverText: tMipManage('kyc.review.decline'),
		},
		REJECTED: {
			textColor: theme.colors.red[6],
			backgroundColor: theme.colors.red[0],
			iconColor: theme.colors.red[6],
			onHoverBackgroundColor: theme.colors.red[0],
			onHoverTextColor: theme.colors.red[6],
			onHoverIconColor: theme.colors.red[6],
			variant: 'close',
			onHoverVariant: 'close',
			text: tMipManage('kyc.review.declined'),
			toolTipText: tMipManage('kyc.review.tooltip.decline'),
			onHoverText: tMipManage('kyc.review.declined'),
		},
		REREQUESTED: {
			textColor: theme.colors.red[6],
			backgroundColor: theme.colors.red[0],
			iconColor: theme.colors.red[6],
			onHoverBackgroundColor: theme.colors.red[0],
			onHoverTextColor: theme.colors.red[6],
			onHoverIconColor: theme.colors.red[6],
			variant: 'close',
			onHoverVariant: 'close',
			text: tMipManage('kyc.review.declined'),
			toolTipText: tMipManage('kyc.review.tooltip.decline'),
			onHoverText: tMipManage('kyc.review.declined'),
		},
	};
	return buttonData;
};
